import * as React from 'react'
import { AsyncButton, Button, Checkbox, FormField, Input, Label, Select, useToast } from 'uxp/components'
import jp from 'jsonpath'
import { Link, Route, Switch } from 'react-router-dom'
import { buildUrl } from '../../util'
import { IContextProvider } from '../../uxp'

interface IConfigProps {
    uxpContext: IContextProvider
}

const UXPBaseURL = 'https://uxp.s3.amazonaws.com'
const LocalScript = 'http://localhost:5501/dist/main.js'
const LocalUXPScript = 'http://localhost:5500/dist/main.js'
const LocalUXPStyles = 'http://localhost:5500/assets/styles/css/uxp_dashboard.css'

const ConfigComponent: React.FunctionComponent<IConfigProps> = (props) => {

    let toast = useToast()

    let [fields, setFields] = React.useState({
        uxpClient: {
            useLocal: false,
            scriptPath: LocalUXPScript,
            stylesPath: LocalUXPStyles,
            version: 'master'
        },
        designer: {
            useLocal: false,
            path: LocalScript
        }
    })

    React.useEffect(() => {
        getConfigs()
    }, [props.uxpContext])

    function getConfigs() {
        props.uxpContext.executeService('UXP', 'GetDesignerConfigs', {}, { json: true })
            .then(res => {
                let { script, uxpScript, uxpStyles } = res[0]
                let designerUseLocal = (script && script.trim().length > 0)
                let uxpClientUseLocal = (!uxpScript.startsWith(UXPBaseURL) && !uxpStyles.startsWith(UXPBaseURL))
                let version = 'master'
                if (!uxpClientUseLocal) {
                    if (uxpScript.startsWith(UXPBaseURL)) {
                        version = uxpScript.replace(`${UXPBaseURL}/dist/`, " ").trim().split("/")[0]
                    }
                    else if (uxpStyles.startsWith(UXPBaseURL)) {
                        version = uxpStyles.replace(`${UXPBaseURL}/dist/`, " ").trim().split("/")[0]
                    }
                }

                // resetting to defaults 
                if (uxpClientUseLocal && uxpScript.startsWith(UXPBaseURL)) {
                    uxpScript = 'https://localhost:5500/dist/main.js'
                }
                if (uxpClientUseLocal && uxpStyles.startsWith(UXPBaseURL)) {
                    uxpStyles = LocalUXPStyles
                }
                if (designerUseLocal && script.startsWith(UXPBaseURL)) {
                    script = LocalScript
                }

                setFields({
                    designer: {
                        useLocal: designerUseLocal,
                        path: script || LocalScript
                    },
                    uxpClient: {
                        useLocal: uxpClientUseLocal,
                        version: version,
                        scriptPath: uxpScript || LocalUXPScript,
                        stylesPath: uxpStyles || LocalUXPStyles
                    }
                })
                console.log('response ', res);

            })
            .catch(e => {
                console.log('Exception getting congifs ', e);
                toast.error("Unable to get configs")
            })
    }
    function updateFields(path: string, value: any) {
        let _fields = { ...fields }
        jp.apply(_fields, path, () => (value))
        setFields(_fields)
    }

    async function save() {

        return new Promise<any>((done, nope) => {
            let args: any = { script: null, uxpScript: null, uxpStyles: null }
            if (fields?.designer?.useLocal && fields?.designer?.path && fields.designer.path.trim().length > 0) {
                args.script = fields.designer.path.trim()
            }

            if (fields?.uxpClient?.useLocal) {
                if (fields?.uxpClient?.scriptPath && fields.uxpClient.scriptPath.trim().length > 0) {
                    args.uxpScript = fields.uxpClient.scriptPath.trim()
                }
                if (fields?.uxpClient?.stylesPath && fields.uxpClient.stylesPath.trim().length > 0) {
                    args.uxpStyles = fields.uxpClient.stylesPath.trim()
                }
            }
            else {
                let stylePath = `${UXPBaseURL}/dist/${fields.uxpClient.version}/uxp_dashboard.css`
                let scriptPath = `${UXPBaseURL}/dist/${fields.uxpClient.version}/main.js`

                args.uxpScript = scriptPath
                args.uxpStyles = stylePath
            }

            props.uxpContext.executeService('UXP', 'UpdateDesignerConfigs', args, { json: true })
                .then(res => {
                    console.log(" response ", res);
                    done('Done')
                    toast.success("Saved!")
                })
                .catch(e => {
                    console.log("Exception ", e);
                    nope("Error")
                    toast.error('Error')
                })
        })
    }

    return <div className="designer-config-page-block"> <Switch>
        <Route exact path={buildUrl(props.uxpContext, ['config'])}>

            <div className="config-page-container">
                <div className="header">
                    <div className="title">Configurations</div>

                    <div className="description">
                        This is only to use in development environment.
                    </div>
                </div>
                <div className="section">
                    <Label>Designer</Label>
                    <div className="row">
                        <FormField>
                            <Checkbox checked={fields.designer.useLocal}
                                onChange={s => { updateFields('$.designer.useLocal', s) }}
                                label="Use Local"
                            />
                        </FormField>

                        {fields.designer.useLocal && <>
                            <FormField>
                                <Label> Path</Label>
                                <Input
                                    value={fields.designer.path}
                                    onChange={s => { updateFields('$.designer.path', s) }}
                                />
                            </FormField>
                        </>}
                    </div>
                </div>

                <div className="section">
                    <Label>UXP Client</Label>
                    <div className="row">
                        <FormField>
                            <Checkbox checked={fields.uxpClient.useLocal}
                                onChange={s => { updateFields('$.uxpClient.useLocal', s) }}
                                label="Use Local"
                            />
                        </FormField>

                        {!fields.uxpClient.useLocal && <>
                            <FormField>
                                <Label>Version</Label>
                                <Select
                                    selected={fields.uxpClient.version}
                                    onChange={s => updateFields('$.uxpClient.version', s)}
                                    options={[
                                        { label: 'Master', value: 'master' },
                                        { label: 'Dev', value: 'dev' },
                                        { label: 'Experimental', value: 'experimental' }
                                    ]}
                                />
                            </FormField>
                        </>}
                    </div>

                    <div className="row">
                        {fields.uxpClient.useLocal &&
                            <>
                                <FormField>
                                    <Label>Script Path</Label>
                                    <Input
                                        value={fields.uxpClient.scriptPath}
                                        onChange={s => updateFields('$.uxpClient.scriptPath', s)}
                                    />
                                </FormField>
                                <FormField>
                                    <Label>Style Path</Label>
                                    <Input
                                        value={fields.uxpClient.stylesPath}
                                        onChange={s => updateFields('$.uxpClient.stylesPath', s)}
                                    />
                                </FormField>
                            </>
                        }
                    </div>
                </div>

                <div className='section'>
                    <div className="row">
                        <Link className='uxp-button' to={buildUrl(props.uxpContext, ['config', 'reset'])} >Reset</Link>

                        <AsyncButton
                            title='Save'
                            onClick={save}
                            loadingTitle="Saving..."
                        />
                    </div>
                </div>

            </div>

        </Route>

        <Route exact path={buildUrl(props.uxpContext, ['config/reset'])} render={() => {

            props.uxpContext.executeService('UXP', 'UpdateDesignerConfigs', { script: null, uxpScript: null, uxpStyles: null }, { json: true })
                .then(res => {
                    window.location.href = buildUrl(props.uxpContext, "")
                })
                .catch(e => {
                    console.log('Exception ', e);
                    toast.error("Error")
                })

            return <>resetting...</>
        }} />

    </Switch>
    </div>
}

export default ConfigComponent